import _get from 'lodash/get';


export const getSites = state => _get(state, 'site.byId');
const getSite = (state, id) => _get(getSites(state), id);
export const getSiteStatus = (state, id) => _get(getSite(state, id), 'status');
export const getSiteName = (state, id) => _get(getSite(state, id), 'siteName');
export const getSiteHostName = (state, id) => _get(getSite(state, id), 'hostName');
export const getSiteCampaignId = (state, id) => _get(getSite(state, id), 'campaign');
export const getSitePromotedSite = (state, id) => _get(getSite(state, id), 'promotedSite');
export const getSiteDefaultLang = (state, id) => _get(getSite(state, id), 'defaultLang');
export const getSiteTemplateId = (state, id) => _get(getSite(state, id), 'templateId');
export const getSiteAgeVerify = (state, id) => _get(getSite(state, id), 'siteParams.ageVerify');
export const getSiteTitle = (state, id) => _get(getSite(state, id), 'siteTitle');
export const getSiteKeywords = (state, id) => _get(getSite(state, id), 'siteKeywords');
export const getSiteDescription = (state, id) => _get(getSite(state, id), 'siteDescription');
